var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 16C4.34315 16 3 17.3431 3 19C3 19.5523 3.44772 20 4 20L14 20C14.5523 20 15 19.5523 15 19C15 17.3431 13.6569 16 12 16L6 16ZM1 19C1 16.2386 3.23858 14 6 14L12 14C14.7614 14 17 16.2386 17 19C17 20.6569 15.6569 22 14 22L4 22C2.34315 22 1 20.6569 1 19Z",
    fill: "url(#paint0_linear_2932_8142)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4C7.34315 4 6 5.34315 6 7C6 8.65685 7.34315 10 9 10C10.6569 10 12 8.65685 12 7C12 5.34315 10.6569 4 9 4ZM4 7C4 4.23858 6.23858 2 9 2C11.7614 2 14 4.23858 14 7C14 9.76142 11.7614 12 9 12C6.23858 12 4 9.76142 4 7Z",
    fill: "url(#paint1_linear_2932_8142)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.1415C14 11.5828 14.3111 11.9724 14.7519 11.994C14.8341 11.998 14.9168 12 15 12C17.7614 12 20 9.76142 20 7C20 4.23858 17.7614 2 15 2C14.9168 2 14.8341 2.00203 14.7519 2.00605C14.3111 2.02758 14 2.41719 14 2.85852V3.15134C14 3.64884 14.5025 4 15 4C16.6569 4 18 5.34315 18 7C18 8.65685 16.6569 10 15 10C14.5025 10 14 10.3512 14 10.8487V11.1415Z",
    fill: "url(#paint2_linear_2932_8142)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21C18 21.5523 18.4477 22 19 22H20C21.6569 22 23 20.6569 23 19C23 16.2386 20.7614 14 18 14C17.4477 14 17 14.4477 17 15C17 15.5523 17.4477 16 18 16C19.6569 16 21 17.3431 21 19C21 19.5523 20.5523 20 20 20H19C18.4477 20 18 20.4477 18 21Z",
    fill: "url(#paint3_linear_2932_8142)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2932_8142",
    x1: 3.67143,
    y1: -0.333334,
    x2: 17.9545,
    y2: 32.1054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2932_8142",
    x1: 3.67143,
    y1: -0.333334,
    x2: 17.9545,
    y2: 32.1054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2932_8142",
    x1: 3.67143,
    y1: -0.333334,
    x2: 17.9545,
    y2: 32.1054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2932_8142",
    x1: 3.67143,
    y1: -0.333334,
    x2: 17.9545,
    y2: 32.1054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.ca7ead015fb03627ee2181e4710626e4.svg";
export { ForwardRef as ReactComponent };